import { useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";

import { useFormWithNotification } from "@covertree/hooks";
import { FormTextField } from "@covertree/ui";

import { StepPath } from "@routing/paths";
import { selectLossDetails, setLossDetails } from "@redux/slices";
import { useAppDispatch, useAppSelector } from "@redux/hooks";

import { LossDetailsForm, validation } from "./form";
import { LossTypeRadioGroup } from "./LossTypeRadioGroup";
import { ClaimsForm } from "../ClaimsForm";

export function LossLocation() {
  const dispatch = useAppDispatch();

  const defaultValues = useAppSelector(selectLossDetails);

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: { ...defaultValues },
    resolver: yupResolver(validation),
  });
  const { control } = form;

  const submit = useCallback((formValue: LossDetailsForm) => {
    dispatch(setLossDetails(formValue));
  }, []);

  return (
    <ClaimsForm
      form={form}
      onSubmit={submit}
      navigateToStep={StepPath.ENTER_CLAIMS_DETAILS}>
      <Grid item xs={12} container flexDirection="row" spacing={3}>
        <Grid item xs={12} md={8}>
          <FormTextField
            id="address-input"
            dataTestId="address-input"
            name="lossAddress"
            label="Loss Location"
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormTextField
            id="unit-input"
            dataTestId="unit-input"
            name="lotUnit"
            optional
            label="Unit / Lot#"
            control={control}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} pt={3}>
        <LossTypeRadioGroup control={control} name="lossType" />
      </Grid>
    </ClaimsForm>
  );
}
